export const API_URL = import.meta.env.VITE_SUPABASE_URL || 'http://127.0.0.1:54321';

export const ENDPOINTS = {
  createPaymentIntent: `${API_URL}/functions/v1/create-payment-intent`,
  stripeWebhook: `${API_URL}/functions/v1/stripe-webhook`,
  createBankAccountSetupIntent: `${API_URL}/functions/v1/create-bank-account-setup-intent`,
  updateBankAccountSetupIntent: `${API_URL}/functions/v1/update-bank-account-setup-intent`,
  createCardSetupIntent: `${API_URL}/functions/v1/create-card-setup-intent`,
  updateCardSetupIntent: `${API_URL}/functions/v1/update-card-setup-intent`,
  balancePurchase: `${API_URL}/functions/v1/balance-purchase`,
  balanceApplyToInvoice: `${API_URL}/functions/v1/balance-apply-to-invoice`,
  cartCheckout: `${API_URL}/functions/v1/cart-checkout`,
} as const;